export class MarkAsBrokenParams {

    url : string;
    name : string;
    type : string;
    feedback : string;
    amazonFileName : string;
    amazonFileKey : string;

    constructor(url : string, name : string, type : string, amazonFileName? : string, amazonFileKey? : string) {
        this.url = url;
        this.name = name;
        this.type = type;
        this.amazonFileName = amazonFileName;
        this.amazonFileKey = amazonFileKey;
    }
}
